/**
 * A single row for editing font properties (size, weight, style, alignment).
 */
import React from 'react';
import * as S from './styles/StylingPanel.styles';
import Icon from '../Common/Icon';
import mobileConstants from '../../mobile/commons/MobileFormsConstants';

const FontStylerRow = ({ controlKey, styles, onFontChange }) => {
    return (
        <S.FontStylingRow>
            <S.Label>{styles.name}</S.Label>
            <S.Select
                value={styles.fontSize}
                onChange={e => onFontChange(controlKey, 'fontSize', e.target.value)}
            >
                {mobileConstants.LIST_FONTS.map(size =>
                    <option key={size} value={size}>{size}px</option>
                )}
            </S.Select>
            <S.FontStyleToggles>
                <S.ToggleButton
                    isBold
                    isActive={styles.fontWeight === 'bold'}
                    onClick={() => onFontChange(controlKey, 'fontWeight', styles.fontWeight === 'bold' ? 'normal' : 'bold')}
                >B</S.ToggleButton>
                <S.ToggleButton
                    isItalic
                    isActive={styles.fontStyle === 'italic'}
                    onClick={() => onFontChange(controlKey, 'fontStyle', styles.fontStyle === 'italic' ? 'normal' : 'italic')}
                ><i>I</i></S.ToggleButton>
                {styles.showAlignment && (
                    <>
                        <S.ToggleButton isActive={styles.textAlign === 'left'} onClick={() => onFontChange(controlKey, 'textAlign', 'left')}><Icon name="alignLeft" size={14} /></S.ToggleButton>
                        <S.ToggleButton isActive={styles.textAlign === 'center'} onClick={() => onFontChange(controlKey, 'textAlign', 'center')}><Icon name="alignCenter" size={14} /></S.ToggleButton>
                        <S.ToggleButton isActive={styles.textAlign === 'right'} onClick={() => onFontChange(controlKey, 'textAlign', 'right')}><Icon name="alignRight" size={14} /></S.ToggleButton>
                    </>
                )}
            </S.FontStyleToggles>
        </S.FontStylingRow>
    );
};

export default FontStylerRow;